import { render } from "./JSField.vue?vue&type=template&id=5c11decc"
import script from "./JSField.vue?vue&type=script&lang=js"
export * from "./JSField.vue?vue&type=script&lang=js"

import "./JSField.vue?vue&type=style&index=0&id=5c11decc&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__